import {toJS} from 'utils/immutableUtils';

export const registrationSelector = state => toJS(state.registration);
